import React, { Fragment } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = (theme) => ({
  smartQuote: {
    fontFamily: 'Arial',
    fontSize: '1.6em',
    position: 'relative',
    top: 7,
    padding: 3,
    [theme.breakpoints.down('xs')]: {
      top: 2,
      padding: 1,
      fontSize: '1.4em',
    },
  },
})

const SmartQuotes = (props) => {
  const { classes, quote } = props

  return (
    <Fragment>
      <span className={classes.smartQuote}>“</span>
      {quote}
      <span className={classes.smartQuote}>”</span>
    </Fragment>
  )
}

export default withStyles(styles)(SmartQuotes)



// WEBPACK FOOTER //
// ./src/components/SmartQuotes.js